<template>
  <div id="app">
    <!--    <keep-alive>-->
    <!--      <router-view></router-view>-->
    <!--    </keep-alive>-->
    <transition name="fade" mode="out-in">
      <router-view v-if="isRouterAlive"></router-view>
    </transition>
    <app-loading></app-loading>
  </div>
</template>

<script>
  import AppLoading from "@/views/components/loading";

  export default {
    name: "app",
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      };
    },
    components: {
      AppLoading,
    },
    methods: {
      //页面重新载入函数
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    }
  };
</script>

<style lang="scss">
  @import "./assets/css/base.scss";

  #app {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .el-table-column--selection .cell {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }

  .el-pagination__total {
    margin-left: 10px;
  }

  .pageWrap {
    text-align: left;
    margin-top: 10px;
  }

  .el-form-item__content {
    line-height: 20px;
  }

  .selectFormItem {
    .el-form-item__content {
      width: 279px !important;
      height: 28px !important;
    }

    .selPrepend {
      background-color: #f5f7fa;
      color: #909399;
      vertical-align: top;
      display: inline-block;
      border: 1px solid #dcdfe6;
      border-right: 0;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      padding: 0 20px;
      width: 101px;
      height: 28px;
      line-height: 28px;
      white-space: nowrap;

      .selPrependSpan {
        font-size: 12px;
        color: #909399;
        display: inline-block;
      }
    }

    .sel {
      margin-left: -5px;

      input.el-input__inner {
        border-top-left-radius: 0px !important;
        border-bottom-left-radius: 0px !important;
      }
    }
  }

  .selectTimeFormItem {
    .el-form-item__content {
      width: 600px !important;
      height: 28px !important;
    }

    .selPrepend {
      background-color: #f5f7fa;
      color: #909399;
      vertical-align: top;
      display: inline-block;
      border: 1px solid #dcdfe6;
      border-right: 0;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      padding: 0 20px;
      height: 28px;
      line-height: 28px;
      white-space: nowrap;

      .selPrependSpan {
        font-size: 12px;
        color: #909399;
        display: inline-block;
      }
    }

    .sel {
      margin-left: -5px;
    }
  }

  .specialCls {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    .specialSpan {
      cursor: pointer;
      text-decoration: underline;
      color: rgb(3, 154, 255);
    }
  }

  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }

  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-right: 9px;
  }

  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }

  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 9px;
  }

  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }

  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
    margin: 0;
  }

  .el-dialog__header {
    text-align: center !important;
  }

  .enumCodeBox .el-input-group__prepend {
    width: 113px !important;
  }

  .countCls .el-input__inner {
    text-align: center !important;
  }

  .splitSync .detailMainContent .el-table thead tr th {
    border-bottom: none !important;
  }

  .splitSync .detailMainContent .el-form-item__label {
    color: #909399 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue